import { AnyNode } from "@p0security/shared/types/assessment/data/index";
import { Finding } from "@p0security/shared/types/assessment/finding";
import { Typography } from "@p0security/ui";
import { JiraIcon } from "components/Integrations/Jira/Jira";
import { ResizableTableColumnType } from "components/ResizableTable";

import { stringSorter } from "../sort";

export const AssignmentColumn = (
  fromData: (data: AnyNode) => Finding["issue"] | undefined
): ResizableTableColumnType<AnyNode> => ({
  sorter: (left, right) =>
    stringSorter(fromData(left)?.key ?? "", fromData(right)?.key ?? ""),
  title: "Assignment",
  render: (_: any, data: AnyNode) => {
    const issue = fromData(data);
    return issue ? (
      <Typography.Link
        href={issue.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {JiraIcon}&nbsp;{issue.key}
      </Typography.Link>
    ) : (
      "Unassigned"
    );
  },
  width: 120,
});
